export const shiftDateFormat = 'yyyy-MM-dd'
export const balanceDateFormat = 'dd.MM.yy'
export const dayAndMonthFormat = 'dd.MM'
export const hourAndMinute = 'HH.mm'
